// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

export const cssReset = css({
    fontFamily: "var(--bxp-charlie-text-font-family)",
    h1: {
        fontFamily: "var(--bxp-charlie-display-font-family)"
    },
    h2: {
        fontFamily: "var(--bxp-charlie-display-font-family)"
    },
    h3: {
        fontFamily: "var(--bxp-charlie-display-font-family)"
    },
    h4: {
        fontFamily: "var(--bxp-charlie-display-font-family)"
    },
    h5: {
        fontFamily: "var(--bxp-charlie-display-font-family)"
    },
    h6: {
        fontFamily: "var(--bxp-charlie-display-font-family)"
    },
    input: {
        fontFamily: "var(--bxp-charlie-text-font-family)"
    }
});
